import { Component, OnInit, Input } from "@angular/core";
import { ApirequestService } from "../../../../../shared/services/apirequest.service";
import { MatTableDataSource } from "@angular/material";
import * as moment from "moment/moment";
import { Router, ActivatedRoute } from "@angular/router";
import { FileService } from "src/app/shared/services/file.service";
import { BehaviorSingleUploadComponent } from "./behavior-single-upload/behavior-single-upload.component";

@Component({
  selector: 'app-behaviors-form',
  templateUrl: './behaviors-form.component.html',
  styleUrls: ['./behaviors-form.component.scss']
})
export class BehaviorsFormComponent implements OnInit {
  id: string;
  loading: boolean;
  start_date: string = "";
  end_date: string = "";
  url: string;
  topHeaders: string[] = ["channelGrouping", "acquisition", "behavior"];
  displayedColumns: string[] = [
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  alldisplayedColumns: string[] = [
    "channelGrouping",
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  dataSource: MatTableDataSource<any>;
  behaviorSingleUploadComponent = BehaviorSingleUploadComponent;
  @Input() sourceData: any;

  constructor(
    private apirequestService: ApirequestService,
    private router: Router,
    private route: ActivatedRoute,
    private fileService: FileService
  ) {}

  ngOnInit() {
    // let today = new Date();
    this.route.params.subscribe((params) => {
      this.id = params["id"] || "";
    });

    const currentDate = new Date();
    const dateString = currentDate.toISOString();
    let today = new Date(dateString);
    var lastMonth = new Date(today);
    lastMonth.setDate(lastMonth.getDate() - 30);
    this.start_date = lastMonth.toISOString().slice(0, 10);
    this.end_date = today.toISOString().slice(0, 10);
    this.dataSource = new MatTableDataSource();
    this.getData(this.start_date, this.end_date);
  }

  filter_by_date() {
    this.loading = true;
    this.getData(this.start_date, this.end_date);
  }

  getData(start_date, end_date) {
    if (start_date != "" && end_date != "") {
      var formatedstartDate = moment(start_date).format("YYYY-MM-DD");
      var formatedendDate = moment(end_date).format("YYYY-MM-DD");
      this.url =
        "analytics/traffic-channels/?start_date=" +
        formatedstartDate +
        "&end_date=" +
        formatedendDate;
    } else {
      this.start_date = moment(moment().subtract(30, "days")).format(
        "YYYY-MM-DD"
      );
      this.end_date = moment(moment().subtract(1, "days")).format("YYYY-MM-DD");

      this.url = "analytics/traffic-channels/";
    }
    this.loading = true;
    this.apirequestService.get(this.url).subscribe(
      (data) => {
        this.dataSource.data = data;
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  navigateTo(link: any) {
    console.log(link.toLowerCase().replace(/\s/g, ""));
    this.router.navigate([
      "/statistics/traffic/" + link.toLowerCase().replace(/\s/g, ""),
    ]);
  }

  exportData() {
    var pageSize = 10000;
    this.url =
      "analytics/channels/?start_date=" +
      this.start_date +
      "&end_date=" +
      this.end_date +
      "&export=True";
    this.loading = true;
    this.apirequestService.get(this.url).subscribe(
      (data) => {
        this.loading = false;
        this.fileService.downloadFile(data.file_url);
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }
}
